<template>
    <component :is="tag" v-if="isVisible" v-bind="$_linkAttrs" v-on="$listeners" @click="onClick(row)">
        <slot :row="row" :props="$props">
            <oc-icon v-if="icon" :type="icon" v-bind="iconAttrs" />
            <span v-if="title && displayTitle" v-html="title" />
        </slot>
    </component>
</template>

<script>
export default {
    name: 'oc-action',
    props: {
        title: {
            default: ''
        },
        icon: {
            type: [String, Boolean],
            default: false
        },
        visible: {
            type: [Boolean, Function],
            default: true
        },
        iconAttrs: {
            type: Object,
            default: () => ({})
        },
        row: {
            default: () => ({})
        },
        linkAttrs: {
            type: Object,
            default: () => ({})
        },
        onClick: {
            type: Function,
            default: () => {
                return () => {}
            }
        },
        displayTitle: {
            type: Boolean,
            default: true
        },
        tag: {
            type: String,
            default: 'a'
        }
    },
    computed: {
        $_linkAttrs() {
            let attrs = Object.assign({}, this.$attrs, this.linkAttrs)

            if( this.tag === 'a' && attrs.href === undefined ) {
                attrs.href = 'javascript:;'
            }

            return attrs
        },
        isVisible() {
            if( typeOf(this.visible) === 'function' ) {
                return this.visible(this.row)
            }

            return this.visible === undefined || Boolean(this.visible)
        }
    }
}
</script>

<style scoped>
    a {text-decoration: none;}
</style>
